module.exports = __webpack_public_path__ + "static/media/close-m.6229deda.svg";